import { Injectable } from '@angular/core';
import { LoginVm } from '../../Model/LoginVM';
import { LoginService } from "../../Services/login.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  currentUser: LoginVm = {};
  authKey = 'currentUser';
  constructor(private api: LoginService) { }

  login(data: any): Observable<any> {
    return this.api.login(data).pipe(
      map((data: any) => {
        this.currentUser = {
          userName: data.payload.userName,
          name: data.payload.name,
          phoneNumber: data.payload.phoneNumber,
          userId: data.payload.userId,
          userType: data.payload.userType,
          email: data.payload.email,
          token: data.payload.token,
          userLogo: data.payload.userLogo,
          loggedId: data.payload.loggedId,
          isHaveComparePerm: data.payload.isHaveComparePerm == true,
        };

        this.setStorage(this.authKey, JSON.stringify(this.currentUser));
        return this.currentUser;
      })
    );
  }
  getToken() {
    let jsonObj = this.getStorage(this.authKey);
    if (typeof jsonObj !== 'undefined' && jsonObj !== null) {
      const currentUser = <LoginVm>JSON.parse(jsonObj);
      this.currentUser = currentUser;
      return currentUser?.token;
    }

    return null;
  }

  isAuthenticated(CurrentUserTypes?: number[]): boolean {
    // get the token
    const token = this.getToken();
    // return a boolean indicating whether or not the token is expired
    const checkUserPermission = CurrentUserTypes?.includes(this?.currentUser?.userType!);
    return !this.tokenExpired(token) && (checkUserPermission ?? true);
  }

  tokenExpired(token: any) {
    if (typeof token !== 'undefined' && token !== null) {
      const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
      return (Math.floor((new Date).getTime() / 1000)) >= expiry;
    }
    return true;
  }


  setStorage(key: string, data: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  getStorage(key: string) {
    try {
      const json = JSON.parse(localStorage.getItem(key)!);
      return json;
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }

  updateStorage(key: any) {
    if (localStorage.getItem(key)) {
      const data = this.getStorage(key);
      this.setStorage(key, data);
    }
  }

  removeStorage(key: string) {
    localStorage.removeItem(key);
  }

  getCurrentUser() {
    let jsonObj = this.getStorage("currentUser");
    return <LoginVm>JSON.parse(jsonObj);
  }

  clearStorage() {
    localStorage.clear();
  }
}
